import { ApiValidationErrorDto } from "cy-models";

export function parseAsApiValidationError(
  error: any
): ApiValidationErrorDto | null {
  if (error.status === 422 && error.body) {
    const apiError = error.body as ApiValidationErrorDto;
    apiError.message = apiError.errors
      .map((x) => {
        if (x.errorCode && !x.errorCode.includes("Validator")) {
          return `[${x.errorCode}] ${x.errorMessage}`;
        } else return x.errorMessage;
      })
      .join(", ");
    return apiError;
  }
  return null;
}
